var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.93 31.83l-3.41-2.25V18.6l3.41 2.62v10.61zm-5.36-2.47l-3.41 2.25v-10.6l3.41-2.62v10.97zm-5.35 2.47l-3.42-2.25V18.6l3.42 2.62v10.61zm-5.37-2.47l-3.41 2.25v-10.6l3.41-2.62v10.97zm11.47-13.73l-5.38 3.7-5.09-3.7-6.1 4.35v14.4l5.96-3.2 5.38 3.2 5.74-3.2 5.6 3.2v-14.4l-6.11-4.36z",
    fill: "#FFF"
  })));
});